import { useCallback, useEffect, useState } from 'react';
import { SECRET_STORAGE_KEY } from '../../services/cloneProvider';

export default function useCloneProviderSecret() {
  const [secret, setSecretState] = useState(() => sessionStorage.getItem(SECRET_STORAGE_KEY) || '');

  useEffect(() => {
    function handleInvalid() {
      setSecretState('');
    }
    window.addEventListener('clone-provider-secret-invalid', handleInvalid);
    return () => window.removeEventListener('clone-provider-secret-invalid', handleInvalid);
  }, []);

  const saveSecret = useCallback((value) => {
    sessionStorage.setItem(SECRET_STORAGE_KEY, value);
    setSecretState(value);
  }, []);

  const clearSecret = useCallback(() => {
    sessionStorage.removeItem(SECRET_STORAGE_KEY);
    setSecretState('');
  }, []);

  return { secret, hasSecret: Boolean(secret), saveSecret, clearSecret };
}
